import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = /*#__PURE__*/_createElementVNode("div", null, "请先选择报名组别", -1);
var _hoisted_2 = ["v"];
import { ApplyNewService } from '@/services/applyNew.service';
import { useService } from '@kaokei/use-vue-service';
import { computed } from 'vue';
export default /*#__PURE__*/_defineComponent({
  setup: function (__props) {
    var applyService = useService(ApplyNewService);
    var formState = computed(function () {
      return applyService.formState;
    });
    return function (_ctx, _cache) {
      var _component_a_select = _resolveComponent("a-select");
      var _component_a_form_item = _resolveComponent("a-form-item");
      var _component_a_col = _resolveComponent("a-col");
      return _unref(applyService).needAreaId && _unref(formState).contestScheduleId ? (_openBlock(), _createBlock(_component_a_col, {
        key: 0,
        span: 12
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_a_form_item, {
            label: "考试时间：",
            name: "areaId"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_a_select, {
                allowClear: "",
                size: "large",
                value: _unref(formState).areaId,
                "onUpdate:value": _cache[0] || (_cache[0] = function ($event) {
                  return _unref(formState).areaId = $event;
                }),
                options: _unref(applyService).areaNodeList,
                placeholder: "考试时间："
              }, {
                notFoundContent: _withCtx(function () {
                  return [_hoisted_1];
                }),
                option: _withCtx(function (_a) {
                  var value = _a.value,
                    label = _a.label;
                  return [_createElementVNode("div", {
                    v: value,
                    style: {
                      "height": "40px",
                      "white-space": "wrap"
                    }
                  }, _toDisplayString(label), 9, _hoisted_2)];
                }),
                _: 1
              }, 8, ["value", "options"])];
            }),
            _: 1
          })];
        }),
        _: 1
      })) : _createCommentVNode("", true);
    };
  }
});